import React, { useEffect } from "react";
import { Row, Col, Card, Tag, Divider, Typography } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons'
import HeadingAndText from "../../../../components/HeadingAndText";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getData } from "../../../../actions/apiCall";
import moment from "moment";

const { Text, Title } = Typography;


const MySalary = () => {
    const user = useSelector((state: any) => state?.app?.user);
    const [salaryData, setSalaryData] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        getSalarySummary();
    }, []);


    const getSalarySummary = async () => {
        setLoading(true);
        setSalaryData(null);
        try {
            const resData = await dispatch(getData('/finance/current-salary'));
            if (resData.code === 200) {
                setSalaryData(resData.data);
            }

        } catch (error) {
            console.error("Error fetching salary summary:", error);
        } finally {
            setLoading(false);
        }
    }

    return <>
        {loading && <Card loading={true} style={{ height: '100vh' }} />}
        {!salaryData && !loading && <Card>You don't have access to this page at the moment.</Card>}
        {salaryData && <>
            <Row gutter={[16, 16]} justify="space-between" style={{ marginBottom: 10 }}>
                <Col span={12}>
                    <Card style={{ width: '100%' }}>
                        <HeadingAndText heading={'CURRENT COMPENSATION'} text={`INR ${salaryData?.offered_ctc?.toLocaleString('en-IN')} / Annum`} />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card style={{ width: '100%' }}>
                        <Row gutter={[30, 30]} justify={"start"} align={"middle"}>
                            <Col>
                                <HeadingAndText heading={'Payroll'} />
                            </Col>
                            <Col>
                                <HeadingAndText heading={'Remuneration'} text={'Monthly'} />
                            </Col>
                            <Col>
                                <HeadingAndText heading={'Pay Circle'} text={'Monthly'} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <Card style={{ borderRadius: '8px' }}>
                <Title level={5}>Salary Timeline</Title>
                {/* 
            <Row style={{ marginBottom: '10px' }}>
                <Col span={24}>
                    <div
                        style={{
                            backgroundColor: '#ececff',
                            padding: '10px',
                            borderRadius: '5px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Text>Your Income and tax liability is being computed as per New Tax Regime.</Text>
                    </div>
                </Col>
            </Row> */}

                <Row>
                    <Col span={24}>
                        <Card bordered={true} >
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <Row justify="start" gutter={[16, 16]}>
                                        <Col>
                                            <Text strong>Salary Revision</Text>
                                        </Col>
                                        <Col>
                                            <Tag color="blue">Effective {moment(salaryData?.effective_from).format('MMM D, YYYY')}</Tag>
                                            <Tag color="purple">CURRENT</Tag>
                                        </Col>
                                    </Row>
                                    <Divider />
                                    <Row gutter={[16, 16]}>
                                        <Col span={8}>
                                            <HeadingAndText heading={'Regular Salary'} text={`INR ${salaryData?.offered_ctc?.toLocaleString('en-IN')}`} />
                                        </Col>
                                        <Col span={8}>
                                            <HeadingAndText heading={'Total'} text={`INR ${salaryData?.offered_ctc?.toLocaleString('en-IN')}`} />
                                        </Col>
                                    </Row>
                                    <Row gutter={[16, 16]} style={{ marginTop: '10px' }}>
                                        <Col span={8}>
                                            <HeadingAndText heading={'Salary per Month'} text={`INR ${(salaryData?.offered_ctc / 12)?.toLocaleString('en-IN')}`} />
                                        </Col>
                                        <Col span={8}>
                                            <HeadingAndText heading={'Effective From'} text={moment(salaryData?.effective_from).format('MMM D, YYYY')} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Card>
        </>}
    </>
}

export default MySalary;